import React, { useState, useEffect } from 'react';

const ScrollToTop = () => {
    const [isVisable, setIsVisable] = useState(false);

    useEffect(() => {
        window.addEventListener('scroll', toggleVisibility);
        return () => {
            window.removeEventListener('scroll', toggleVisibility);
        };
    }, []);

    const toggleVisibility = () => {
        if (window.pageYOffset > 700) {
            setIsVisable(true);
        } else {
            setIsVisable(false);
        }
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
        });
    };

    return (
        <>
            {isVisable && (
                <div onClick={() => scrollToTop()} className='scroll-top bg-white d-flex justify-content-center align-items-center'>
                    <span className='oi oi-chevron-top c-light-licorice margin-bottom-5px'></span>
                </div>
            )}
        </>
    );
};

export default ScrollToTop;
